import { useBreakpoint } from '@maersktankersdigital/web-components'
import { Step } from 'react-joyride'
import { ExactScopeName, useHasScope } from '~hooks/permissions/use-has-scope'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import { constructCargoListTour } from './cargo-list-tour'

export interface GuidedTourListItem {
  id: string
  name: string
  status: GuidedTourStatus
  tourStartLink: string
  content: Step[]
  tourPaths: string[]
  startTourPath: string
}

export type GuidedTourStatus = 'Not Seen' | 'Started' | 'Skipped' | 'Completed'

export function useGuidedToursList(): GuidedTourListItem[] {
  const { data, isLoading, isError } = useGetMe()
  const { breakpoint } = useBreakpoint()
  const isCargoListReader = useHasScope(ExactScopeName.charteringRead)
  const isCargoListUpdater = useHasScope(ExactScopeName.charteringUpdate)

  if (isLoading || isError) return []

  const guidedTours = data?.settings?.guidedTours || []

  function getTourStatus(tourId: string): GuidedTourStatus {
    return guidedTours?.find((tour) => tour.id === tourId)?.status ?? 'Not Seen'
  }

  const tours: GuidedTourListItem[] = []

  if (isCargoListReader || isCargoListUpdater) {
    tours.push({
      id: '2',
      name: 'Cargo List',
      status: getTourStatus('2'),
      tourStartLink: '/chartering/cargo-list',
      content: constructCargoListTour({
        breakpoint,
        hasUpdateScope: isCargoListUpdater,
      }),
      tourPaths: ['chartering/cargo-list'],
      startTourPath: 'chartering/cargo-list',
    })
  }

  return tours
}
